import styled, { css } from 'styled-components';
import { NAVIGATION_VIEWPORT_BREAKPOINTS } from '../../../../navigation/constants';
import { NAVIGATION_ITEMS_MAX_WIDTH } from '../../../../navigation/constants/navigation-items-width';
import Typography from '../../../../typography';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { NavigationActionSheetItemsContainer } from '../../NavigationActionSheetItems';
/**
 * Navigation action sheet title container
 */
export const navigationActionSheetTitleContainerStyles = ({ theme }) => css `
	margin: 0 auto;
	width: 100%;
	padding: 0 ${pxToRem(theme.spacing['100'])} 0;
	max-width: ${pxToRem(NAVIGATION_ITEMS_MAX_WIDTH)};
	color: ${theme.colors.base.textTitles};

	+ ${NavigationActionSheetItemsContainer} {
		margin-top: ${pxToRem(theme.spacing['100'])};
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		padding: 0;

		+ ${NavigationActionSheetItemsContainer} {
			margin-top: ${pxToRem(theme.spacing['300'])};
		}
	}
`;
export const NavigationActionSheetTitleContainer = styled(Typography) `
	${navigationActionSheetTitleContainerStyles}
`;
